<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 选项卡 -->
    <!-- <div class="selectTop mgb-10" v-if="isHomeOrder">
      <div
        :class="selectActive === v.id ? 'selectActive' : 'select'"
        v-for="(v, i) in selectArr"
        :key="i"
        @click="changeSelect(v)"
      >
        {{ v.name }}
      </div>
    </div> -->
    <!-- 表单查询 -->
    <div class="form mgt-20 pdt-10  bg-white" v-if="selectActive == 1">
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="订单编号">
          <el-input
            v-model="form.orderNo"
            placeholder="请输入订单编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input
            v-model="form.equipmentNum"
            placeholder="请输入设备编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="水卡编号">
          <el-input
            v-model="form.waterCard"
            placeholder="请输入水卡编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否退款">
          <el-select v-model="form.isRefund" placeholder="全部">
            <el-option label="是" value="true"></el-option>
            <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属分区">
          <el-select
            multiple
            filterable
            v-model="form.fenqu"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- = -->
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="交易时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="$forceUpdate()"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="$forceUpdate()"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select multiple v-model="form.payType" placeholder="全部">
            <el-option label="微信" value="2"></el-option>
            <el-option label="电子水卡" value="1"></el-option>
            <el-option label="实物水卡" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否空分">
          <el-select v-model="form.isKf" placeholder="全部" clearable>
            <el-option label="是" value="true"></el-option>
            <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户电话">
          <el-input
            v-model="form.userId"
            placeholder="请输入用户电话"
          ></el-input>
        </el-form-item>
        <el-form-item class="mgl-10">
          <el-button
            type="primary"
            class="mgr-20"
            @click="
              getList();
              getData();
            "
            >查询</el-button
          >
          <el-button @click="chongzhi">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表单查询 -->
    <div class="form mgt-20 pdt-10  bg-white" v-if="selectActive == 2">
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="订单编号">
          <el-input
            v-model="form.orderNo"
            placeholder="请输入订单编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input
            v-model="form.equipmentNum"
            placeholder="请输入设备编号"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否退款">
          <el-select v-model="form.isRefund" placeholder="全部">
            <el-option label="是" value="true"></el-option>
            <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="水卡编号">
          <el-input
            v-model="form.waterCard"
            placeholder="请输入水卡编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属分区">
          <el-select
            multiple
            filterable
            v-model="form.fenqu"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- = -->
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <!-- <el-form-item label="支付方式">
          <el-select multiple v-model="form.payType" placeholder="全部">
            <el-option label="微信" value="2"></el-option>
            <el-option label="电子水卡" value="1"></el-option>
            <el-option label="实物水卡" value="3"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="用户电话">
          <el-input
            v-model="form.userId"
            placeholder="请输入用户电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="交易时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="mgl-10">
          <el-button
            type="primary"
            class="mgr-20"
            @click="
              getList_ro();
              getData_ro();
            "
            >查询</el-button
          >
          <el-button @click="chongzhi">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 订单详情 -->
    <!-- =======企业订单======= -->
    <div class="firmOrder">
      <!-- 合计与导出 -->
      <div class="flex aic jcsb mgt-20 mgb-20 color052154">
        <div>
          <span class="mgr-30">合计订单数（笔）：{{ orderNum }}</span>
          <span class="mgr-30">合计订单金额：¥{{ orderMoney }}</span>
          <!-- <span v-if="selectActive == 2">合计购水量(L)：{{ allWaterNum }}</span> -->
        </div>
      </div>
      <btns @exec="exec" class="mgb-15"></btns>

      <div v-show="selectActive == 1">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column
            type="index"
            :index="indexMethod"
            label="序号"
            width="80"
            fixed="left"
          >
          </el-table-column>
          <el-table-column prop="orderNo" label="订单编号"> </el-table-column>
          <el-table-column prop="waterCard" label="水卡编号">
            <template slot-scope="scope">
              <span
                v-text="scope.row.waterCard ? scope.row.waterCard : '- -'"
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="用户电话"> </el-table-column>
          <el-table-column prop="equipmentNum" label="设备编号">
          </el-table-column>
          <el-table-column prop="equipmentName" label="设备名称">
          </el-table-column>
          <el-table-column prop="regionName" label="所属分区">
          </el-table-column>
          <el-table-column prop="buyWater" label="购水量"> </el-table-column>
          <el-table-column prop="realWater" label="实际出水量">
          </el-table-column>

          <el-table-column prop="orderPrice" label="订单金额（元）">
          </el-table-column
          ><el-table-column prop="refundPrice" label="退款金额（元）">
          </el-table-column>
          <el-table-column prop="payPrice" label="消费金额(赠送/实付)">
            <template slot-scope="scope">
              <span
                v-text="
                  (
                    Number(scope.row.payPrice) +
                    Number(scope.row.walletDiscountPrice)
                  ).toFixed(2) +
                    '（' +
                    scope.row.walletDiscountPrice +
                    '/' +
                    scope.row.payPrice +
                    '）'
                "
              ></span>
            </template> </el-table-column
          ><el-table-column prop="payType" label="支付方式">
            <template slot-scope="scope">
              <span
                v-text="
                  scope.row.payType === 2
                    ? '微信'
                    : scope.row.payType === 1
                    ? '电子水卡'
                    : scope.row.payType === 3
                    ? '实物水卡'
                    : '- -'
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="payType" label="是否时效卡支付">
            <template slot-scope="scope">
              <span v-text="scope.row.isTimePackage ? '是' : '否'"></span>
            </template>
          </el-table-column>
          <el-table-column prop="payType" label="是否空分">
            <template slot-scope="scope">
              <span v-text="scope.row.isKf ? '是' : '否'"></span>
            </template>
          </el-table-column>

          <el-table-column prop="payTime" label="交易时间"> </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="lookDeatils(scope.row)"
                >订单详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-show="selectActive == 2">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column
            type="index"
            :index="indexMethod"
            label="序号"
            width="80"
            fixed="left"
          >
          </el-table-column>
          <el-table-column prop="orderNo" label="订单编号"> </el-table-column>
          <el-table-column prop="waterCard" label="水卡编号"> </el-table-column>

          <!-- <el-table-column prop="payNo" label="支付流水号">
            <template slot-scope="scope">
              <span v-text="scope.row.payNo ? scope.row.payNo : '- -'"></span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="userNum" label="用户编号"> </el-table-column> -->
          <!-- <el-table-column prop="waterCard" label="水卡编号">
            <template slot-scope="scope">
              <span
                v-text="scope.row.waterCard ? scope.row.waterCard : '- -'"
              ></span>
            </template>
          </el-table-column> -->

          <el-table-column prop="phone" label="用户电话">
            <template slot-scope="scope">
              <span v-text="scope.row.phone ? scope.row.phone : '- -'"></span>
            </template>
          </el-table-column>
          <el-table-column prop="equipmentNum" label="设备编号">
          </el-table-column>
          <el-table-column prop="equipmentName" label="设备名称">
          </el-table-column>
          <el-table-column prop="payType" label="支付类型">
            <template slot-scope="scope">
              <span
                v-text="
                  scope.row.payType === 2
                    ? '微信'
                    : scope.row.payType === 1
                    ? '电子水卡'
                    : '实物水卡'
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="payType" label="是否空分">
            <template slot-scope="scope">
              <span
                v-text="scope.row.isKf && scope.row.isKf == true ? '是' : '否'"
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="customerName" label="订单归属">
          </el-table-column>
          <el-table-column prop="regionName" label="所属分区">
          </el-table-column>

          <el-table-column prop="realWater" label="合计出水量">
          </el-table-column>

          <el-table-column prop="payPrice" label="消费金额(赠送/实付)">
            <template slot-scope="scope">
              <span
                v-text="
                  (
                    Number(scope.row.payPrice) +
                    Number(scope.row.walletDiscountPrice)
                  ).toFixed(2) +
                    '（' +
                    scope.row.walletDiscountPrice +
                    '/' +
                    scope.row.payPrice +
                    '）'
                "
              ></span>
            </template>
          </el-table-column>

          <el-table-column prop="upTime" label="订单上报时间">
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="homeListDetail(scope.row)"
                >详情</el-button
              >
              <!-- <el-button type="text" size="small" @click="lookDeatils(scope.row)"
              >订单详情</el-button
            > -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页器 -->
      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout=" prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 订单详情弹框 -->
    <el-dialog
      title="订单详情"
      :visible.sync="detailVisible"
      width="35%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <!-- 水路信息 -->
      <div style="color: #5aa7fd;margin-bottom: 10px;">水路信息</div>
      <el-table :data="waterTable" style="width: 100%" border>
        <el-table-column prop="waterNum" label="水路"> </el-table-column>
        <el-table-column prop="waterType" label="出水类型"> </el-table-column>
        <el-table-column prop="waterNumber" label="实际出水量">
        </el-table-column>
        <el-table-column prop="unitPrice" label="单价(元/L)"> </el-table-column>
        <el-table-column prop="price" label="订单金额"> </el-table-column>
      </el-table>
      <!-- 支付信息 -->
      <div style="color: #5aa7fd;margin-bottom: 10px;margin-top: 15px;">
        支付信息
      </div>
      <el-table :data="payTable" style="width: 100%" border>
        <el-table-column prop="cardNo" label="水卡编号"> </el-table-column>
        <el-table-column prop="name" label="消费前水卡余额(赠送/实付)">
          <template slot-scope="scope">
            <span>{{
              (
                scope.row.waterBeforePayPrice + scope.row.waterBeforeSendPrice
              ).toFixed(2) +
                "（" +
                scope.row.waterBeforeSendPrice +
                "/" +
                scope.row.waterBeforePayPrice +
                "）"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="消费金额(赠送/实付)">
          <template slot-scope="scope">
            <span>{{
              (scope.row.waterPayPrice + scope.row.waterSendPrice).toFixed(2) +
                "（" +
                scope.row.waterSendPrice +
                "/" +
                scope.row.waterPayPrice +
                "）"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="消费后水卡余额(赠送/实付)">
          <template slot-scope="scope">
            <span>{{
              (
                scope.row.waterAfterPayPrice + scope.row.waterAfterSendPrice
              ).toFixed(2) +
                "（" +
                scope.row.waterAfterSendPrice +
                "/" +
                scope.row.waterAfterPayPrice +
                "）"
            }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">已知晓</el-button>
      </span>
    </el-dialog>

    <!-- 导出弹框 -->
    <el-dialog
      title="导出"
      :visible.sync="exportVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <div class="mgb-10">温馨提示:不填写条件则导出全部</div>
      <el-form
        :rules="exportFormRules"
        ref="exportForm"
        :model="exportForm"
        label-width="80px"
      >
        <!-- <el-form-item label="所属分区">
          <el-select
            multiple
            clearable
            filterable
            v-model="exportForm.fenqu"
            placeholder="全部"
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="支付类型">
          <el-select
            multiple
            clearable
            v-model="exportForm.type"
            placeholder="全部"
          >
            <el-option label="微信" value="2"></el-option>
            <el-option label="电子水卡" value="1"></el-option>
            <el-option label="实物水卡" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否退款">
          <el-select clearable v-model="exportForm.isRefund" placeholder="全部">
            <el-option label="是" value="true"></el-option>
            <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易时间">
          <div class="flex">
            <el-date-picker
              v-model="exportForm.startTime"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="开始日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="exportForm.endTime"
              :picker-options="pickerOptionsEnd8"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <!-- <el-form-item label="页码" prop="pageNum">
          <el-input
            v-model="exportForm.pageNum"
            placeholder="请输入页码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="每页条数" prop="pageSize">
          <el-input
            v-model="exportForm.pageSize"
            placeholder="请输入每页条数"
            clearable
          ></el-input>
        </el-form-item> -->

        <el-form-item label="是否空分">
          <el-radio-group v-model="exportKongFen">
            <el-radio :label="0">全部</el-radio>
            <el-radio :label="1">无空分订单</el-radio>
            <el-radio :label="2">仅含空分订单</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="exportVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="exportBtn('exportForm')"
          >导 出</el-button
        >
      </span>
    </el-dialog>

    <!-- 导出选择数据弹框 -->
    <el-dialog
      title="导出"
      :visible.sync="exportChangeNumVisible"
      width="50%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <el-descriptions column="5" border title="请选择需要导出的数据">
        <el-descriptions-item v-for="(v, i) in radioArr" :key="i" label="范围">
          <el-radio v-model="radio" :label="v.id" @input="changeRadioInput">{{
            v.start + "-" + v.end + "条"
          }}</el-radio></el-descriptions-item
        >
      </el-descriptions>

      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="exportChangeNumVisible = false"
          >关 闭</el-button
        >
        <el-button type="primary" @click="exportNumBtn">导 出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import store from "../../store";

export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      selectArr: [
        { name: "社区净水器", id: 1 },
        { name: "家用净水器", id: 2 },
      ],
      selectActive: 1,
      form: {}, //表单
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 10, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      tableData: [],
      orderNum: "",
      orderMoney: "",
      zoneArr: [],
      allWaterNum: 0,
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      isHomeOrder: false,
      waterTable: [],
      payType: [],
      detailVisible: false,
      exportVisible: false,
      exportForm: {
        type: "",
        isRefund: "",
        startTime: "",
        endTime: "",
      },
      pickerOptionsEnd8: {
        disabledDate: (time) => {
          let beginDateVal = this.exportForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      radio: "1",
      radioArr: [],
      exportChangeNumVisible: false,
      exportNum: null,
      interval: 2000,
      companyId: null,

      // 新增导出弹窗增加是否含空分选项
      exportKongFen: 0,
    };
  },
  created() {
    this.getROLE();

    this.getList();
    this.getData();
    this.getZone();
    this.getServer();
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
    "exportForm.startTime"() {
      if (this.exportForm.startTime == null) {
        this.exportForm.endTime = null;
      }
    },
  },
  methods: {
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.companyId = token.companyId;
      }
    },
    exportNumBtn() {
      if (!this.radio) {
        handleAlert("请选择条数范围", "error");
        return;
      }
      this.radioArr.forEach((v) => {
        if (this.radio == v.id) {
          this.exportForm.limitStart = v.start;
          this.exportForm.limitEnd = v.end;
        }
      });
      let xiaofeiExportData = {
        companyId: this.companyId,

        payType: this.exportForm.type,
        isRefund: this.exportForm.isRefund,
        startTime: this.exportForm.startTime,
        endTime: this.exportForm.endTime,
        pageNum: this.exportForm.pageNum,
        pageSize: this.exportForm.pageSize,
        // regionId: this.exportForm.fenqu,
        type: 1,
        limitEnd: this.exportForm.limitEnd,
        limitStart: this.exportForm.limitStart,
      };
      if (this.exportKongFen == 1) {
        // eslint-disable-next-line no-const-assign
        xiaofeiExportData.isKf = false;

        //
      }
      if (this.exportKongFen == 2) {
        // eslint-disable-next-line no-const-assign
        xiaofeiExportData.isKf = true;
      }
      handleConfirm("确认导出吗?", "info")
        .then(() => {
          this.$api.order.xiaofeiExport(xiaofeiExportData).then((res) => {
            handleAlert("导出成功", "success");
            // this.exportChangeNumVisible = false;
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = URL.createObjectURL(res);
            link.setAttribute(
              "download",
              `消费订单(${this.exportForm.limitStart}-${this.exportForm.limitEnd}).xls`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
        })
        .catch(() => {
          return;
        });
    },
    exportBtn(d) {
      // 导出是否空分
      let xiaofeiExportNumData = {
        companyId: this.companyId,

        payType: this.exportForm.type,
        isRefund: this.exportForm.isRefund,
        startTime: this.exportForm.startTime,
        endTime: this.exportForm.endTime,
        pageNum: this.exportForm.pageNum,
        pageSize: this.exportForm.pageSize,
        // regionId: this.exportForm.fenqu,
        type: 0,
      };
      let topExportData = {};
      if (this.exportKongFen == 1) {
        // eslint-disable-next-line no-const-assign
        xiaofeiExportNumData.isKf = false;

        //
      }
      if (this.exportKongFen == 2) {
        // eslint-disable-next-line no-const-assign
        xiaofeiExportNumData.isKf = true;
      }
      this.$refs[d].validate((valid) => {
        if (valid) {
          this.$api.order.xiaofeiExportNum(xiaofeiExportNumData).then((a) => {
            console.log(a, "aa");

            if (a.code === 200) {
              if (Number(a.data) > this.interval) {
                console.log(666);

                this.radioArr = []; // 清空之前的范围
                let id = 1; // 从1开始递增的ID
                for (let i = 0; i < a.data; i += this.interval) {
                  const end = Math.min(i + this.interval - 1, a.data - 1);
                  this.radioArr.push({ id, start: i + 1, end: end + 1 });
                  id++;
                }
                this.exportVisible = false;
                this.radio = "";
                this.exportChangeNumVisible = true;
              } else {
                topExportData = {
                  companyId: this.companyId,

                  payType: this.exportForm.type,
                  isRefund: this.exportForm.isRefund,
                  startTime: this.exportForm.startTime,
                  endTime: this.exportForm.endTime,
                  pageNum: this.exportForm.pageNum,
                  pageSize: this.exportForm.pageSize,
                  // regionId: this.exportForm.fenqu,
                  type: 1,
                  limitStart: 1,
                  limitEnd: a.data,
                };
                if (this.exportKongFen == 1) {
                  // eslint-disable-next-line no-const-assign
                  topExportData.isKf = false;

                  //
                }
                if (this.exportKongFen == 2) {
                  // eslint-disable-next-line no-const-assign
                  topExportData.isKf = true;
                }
                handleConfirm("确认导出吗?", "info")
                  .then(() => {
                    this.$api.order.xiaofeiExport(topExportData).then((res) => {
                      this.exportVisible = false;
                      const link = document.createElement("a");
                      link.style.display = "none";
                      link.href = URL.createObjectURL(res);
                      link.setAttribute("download", "消费订单.xls");
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                      handleAlert("导出成功", "success");
                    });
                  })
                  .catch(() => {
                    return;
                  });
              }
            }
          });
        } else {
          return false;
        }
      });
    },
    export() {
      this.exportVisible = true;
      // this.exportForm = {
      //   qiye: [],
      //   type: [],
      //   fenqu: [],
      //   isRefund: "",
      //   startTime: "",
      //   endTime: "",
      //   pageNum: 1,
      //   pageSize: 500000,
      // };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.exportForm.clearValidate();
      });
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    getData_ro() {
      this.$api.order
        .orderListStatNew_ro({
          endTime: this.form.endTime,
          equipmentNum: this.form.equipmentNum,
          isRefund: this.form.isRefund,
          orderNo: this.form.orderNo,
          payType: this.form.payType,
          startTime: this.form.startTime,
          phone: this.form.userId,
          regionId: this.form.fenqu,
          waterCard: this.form.waterCard,

          payChannel: 4,
        })
        .then((d) => {
          if (d.code === 200) {
            this.orderNum = d.data.orderNum;
            this.allWaterNum = d.data.waterNum;
            this.orderMoney = (
              Number(d.data.discountPrice) + Number(d.data.payPrice)
            ).toFixed(2);
          }
        });
    },
    getList_ro(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.order
        .orderList_ro({
          pageNum: this.page,
          pageSize: this.pageSize,
          endTime: this.form.endTime,
          equipmentNum: this.form.equipmentNum,
          isRefund: this.form.isRefund,
          orderNo: this.form.orderNo,
          payType: this.form.payType,
          startTime: this.form.startTime,
          phone: this.form.userId,
          regionId: this.form.fenqu,
          waterCard: this.form.waterCard,

          payChannel: 4,
        })
        .then((res) => {
          if (res.code === 200) {
            this.total = res.data.total;
            this.tableData = res.data.rows;
            // this.tableData = [{ name: "" }];
            this.tableData.forEach((v) => {
              if (v.equipmentSku) {
                let obj = JSON.parse(v.equipmentSku);
                v.buyWater = obj.出水量;
              }
            });
          }
        });
    },
    // 家用机订单详情弹框
    homeListDetail(row) {
      let waterInfo = row.waterMessageDto;
      this.waterTable = [
        {
          price:
            waterInfo.onePrice > 0
              ? (
                  Number(row.payPrice) + Number(row.walletDiscountPrice)
                ).toFixed(2)
              : waterInfo.onePrice <= 0 && !waterInfo.type.includes("单出水")
              ? (
                  Number(row.payPrice) + Number(row.walletDiscountPrice)
                ).toFixed(2)
              : "- -",
          unitPrice:
            waterInfo.oneUnitPrice > 0
              ? waterInfo.oneUnitPrice
              : waterInfo.oneUnitPrice <= 0 &&
                !waterInfo.type.includes("单出水")
              ? waterInfo.oneUnitPrice
              : "- -",
          // waterNumber:
          //   waterInfo.oneWaterNumber > 0
          //     ? waterInfo.oneWaterNumber / 1000
          //     : waterInfo.oneWaterNumber <= 0 &&
          //       !waterInfo.type.includes("单出水")
          //     ? waterInfo.oneWaterNumber / 1000
          //     : "- -",
          waterNumber:
            waterInfo.onePrice > 0
              ? row.realWater
              : waterInfo.onePrice <= 0 && !waterInfo.type.includes("单出水")
              ? row.realWater
              : "- -",
          waterType:
            waterInfo.oneWaterType !== "" ? waterInfo.oneWaterType : "- -",
          waterNum:
            waterInfo.oneUnitPrice > 0
              ? "水路一"
              : waterInfo.oneUnitPrice <= 0 &&
                !waterInfo.type.includes("单出水")
              ? "水路一"
              : "- -",
        },
        {
          price:
            waterInfo.twoPrice > 0
              ? (
                  Number(row.payPrice) + Number(row.walletDiscountPrice)
                ).toFixed(2)
              : waterInfo.twoPrice <= 0 && !waterInfo.type.includes("单出水")
              ? (
                  Number(row.payPrice) + Number(row.walletDiscountPrice)
                ).toFixed(2)
              : "- -",
          unitPrice:
            waterInfo.towUnitPrice > 0
              ? waterInfo.towUnitPrice
              : waterInfo.towUnitPrice <= 0 &&
                !waterInfo.type.includes("单出水")
              ? waterInfo.towUnitPrice
              : "- -",
          // waterNumber:
          //   waterInfo.towWaterNumber > 0
          //     ? waterInfo.towWaterNumber / 1000
          //     : waterInfo.towWaterNumber <= 0 &&
          //       !waterInfo.type.includes("单出水")
          //     ? waterInfo.towWaterNumber / 1000
          //     : "- -",
          waterNumber:
            waterInfo.twoPrice > 0
              ? row.realWater
              : waterInfo.twoPrice <= 0 && !waterInfo.type.includes("单出水")
              ? row.realWater
              : "- -",
          waterType:
            waterInfo.towWaterType !== "" ? waterInfo.towWaterType : "- -",
          waterNum:
            waterInfo.towUnitPrice > 0
              ? "水路二"
              : waterInfo.towUnitPrice <= 0 &&
                !waterInfo.type.includes("单出水")
              ? "水路二"
              : "- -",
        },
      ];
      this.payTable = row.waterMessagePriceDtos;
      this.detailVisible = true;
    },
    changeSelect(v) {
      this.selectActive = v.id;
      if (this.selectActive == 1) {
        this.getList();
        this.getData();
      } else {
        this.getList_ro();
        this.getData_ro();
      }
    },
    // 服务端
    getServer() {
      this.$api.home.serverHttp().then((res) => {
        if (res.code === 200) {
          this.isHomeOrder = res.data.some(
            (item) => item.id === 3 || item.id === "3"
          );
        }
      });
    },
    lookDeatils(row) {
      this.$router.push({
        path: "/ordermanagement/details/spentDeatils_have",
        query: {
          orderNo: row.orderNo,
        },
      });
    },
    chongzhi() {
      this.form = { fenqu: [], startTime: "", endTime: "" };
      if (this.selectActive == 1) {
        this.getList();
        this.getData();
      } else {
        this.getList_ro();
        this.getData_ro();
      }
    },

    getData() {
      this.$api.order
        .orderListStatNew({
          endTime: this.form.endTime,
          equipmentNum: this.form.equipmentNum,
          isRefund: this.form.isRefund,
          orderNo: this.form.orderNo,
          payType: this.form.payType,
          startTime: this.form.startTime,
          phone: this.form.userId,
          regionId: this.form.fenqu,
          waterCard: this.form.waterCard,
          isKf: this.form.isKf,
        })
        .then((d) => {
          if (d.code === 200) {
            this.allWaterNum = d.data.waterNum ? d.data.waterNum : 0;
            this.orderNum = d.data.orderNum;
            // this.orderMoney = (
            //   Number(d.data.discountPrice) + Number(d.data.payPrice)
            // ).toFixed(2);
            this.orderMoney = (
              Number(d.data.orderPrice) - Number(d.data.refundPrice)
            ).toFixed(2);
          }
        });
    },

    getZone() {
      this.$api.marketing.allZonePull().then((res) => {
        if (res.code === 200) {
          this.zoneArr = res.data;
        }
      });
    },

    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.order
        .orderList({
          pageNum: this.page,
          pageSize: this.pageSize,
          endTime: this.form.endTime,
          equipmentNum: this.form.equipmentNum,
          isRefund: this.form.isRefund,
          orderNo: this.form.orderNo,
          payType: this.form.payType,
          startTime: this.form.startTime,
          phone: this.form.userId,
          waterCard: this.form.waterCard,

          regionId: this.form.fenqu,
          isKf: this.form.isKf,
        })
        .then((res) => {
          if (res.code === 200) {
            this.total = res.data.total;
            this.tableData = res.data.rows;
            // this.tableData = [{ name: "" }];
            this.tableData.forEach((v) => {
              if (v.equipmentSku) {
                let obj = JSON.parse(v.equipmentSku);
                v.buyWater = obj.出水量;
              }
            });
          }
        });
    },
    // 根据订单状态选择相对应的订单
    handClickState(item) {
      this.currentOrderState = item;
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      if (this.selectActive == 1) {
        this.getList(this.page);
      } else {
        this.getList_ro(this.page);
      }
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      console.log(val);
      this.page = val;
      if (this.selectActive == 1) {
        this.getList(this.page);
      } else {
        this.getList_ro(this.page);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.selectTop {
  display: flex;
  justify-content: center;
  .select {
    width: 30%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: var(--card-bg);
    cursor: pointer;
  }
  .selectActive {
    width: 30%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: var(--accent);
    color: #fff;
    cursor: pointer;
  }
}
//  头部企业和代理选择
.header-select {
  .firm-btn {
    padding: 10px 70px;
    background: var(--card-bg);
    border: 1px solid var(--input-border);
    margin-right: 100px;
    cursor: pointer;
  }
  .firm-btn-active {
    padding: 10px 70px;
    background: var(--accent);
    border: 1px solid var(--accent);
    margin-right: 100px;
    color: #fff;
    cursor: pointer;
  }
  .agency-btn {
    padding: 10px 70px;
    background: var(--card-bg);
    border: 1px solid var(--input-border);
    cursor: pointer;
  }
  .agency-btn-active {
    padding: 10px 70px;
    background: var(--accent);
    border: 1px solid var(--accent);
    color: #fff;
    cursor: pointer;
  }
}
// 根据订单状态查看订单
.orderStateSelect {
  padding: 10px 50px;
  background: var(--card-bg);
  border: 2px solid var(--input-border);
  cursor: pointer;
  margin-right: 50px;
}
.orderStateSelect-active {
  padding: 10px 50px;
  background: var(--accent);
  border: 2px solid var(--accent);
  color: #fff;
  cursor: pointer;
  margin-right: 50px;
}
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}
</style>
